import InputView from '../../../../FormSteps/InputView'
import RegistrationFormPage from '../Base/RegistrationFormPage'

const RegistrationPage: InputView = ({ path }) => (
  <RegistrationFormPage
    path={path}
    requirePassword={true}
    heading='Create your account'
    metaTitle='New HeadBox Business user - HeadBox'
    marketingCopy={
      <>
        <h4>Stay in the loop</h4>
        <p>
          Get the newest and best venues, exclusive HeadBox Connect event invitations, product
          developments and industry news delivered straight to your inbox. You can unsubscribe at
          any time.
        </p>
      </>
    }
  />
)

export default RegistrationPage
